import { useDispatch, useSelector } from "react-redux";
import "../manage.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  removeVideo,
  setVideoOnEdit,
  setVideos,
} from "../../Redux/Actions/videoActions";

const ManageVideo = () => {
  const dispatch = useDispatch();
  const [videos, setVideosList] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const loggedUser = useSelector((state) => state.users.loggedUser);
  const isLoggedIn = Object.keys(loggedUser).length > 0;
  const navigate = useNavigate();

  if (!isLoggedIn) {
    navigate("/login");
  }

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://api.arkiva.gov.al/api/video?page=${currentPage}&limit=20`,
        );
        setVideosList(response.data.videos);
        setTotalPages(response.data.totalPages);
        dispatch(setVideos(response.data.videos));
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
      setLoading(false);
    };

    if (isLoggedIn) {
      fetchVideos();
    } else {
      navigate("/login");
    }
  }, [dispatch, isLoggedIn, navigate, currentPage]);

  const editVideo = (video) => {
    navigate(`/manage/video/${video._id}`);
    dispatch(setVideoOnEdit(video));
  };

  const addVideo = () => {
    navigate("/manage/video/add-new");
  };

  const deleteVideo = async (video) => {
    try {
      const response = await axios.delete(
        `https://api.arkiva.gov.al/api/video/delete/${video._id}`,
        { data: { id: video.id } },
      );
      if (response.data.message === "error") {
        alert("Something went wrong!");
      } else {
        setVideosList((prevVideos) =>
          prevVideos.filter((v) => v._id !== response.data.videoId),
        );
        dispatch(removeVideo(response.data.videoId));
      }
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };

  const filteredVideos = videos.filter((item) =>
    item.title.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="manage-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="manage-page-header">
        <div className="manage-page-header-actions">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button onClick={addVideo}>
            <i className="fa-solid fa-plus"></i> Shto Video
          </button>
        </div>
      </div>
      <div className="manage-table">
        <table className="table">
          <thead>
            <tr>
              <th>Titulli</th>
              <th>Data e krijimit</th>
              <th>Veprime</th>
            </tr>
          </thead>
          <tbody>
            {filteredVideos.length > 0 ? (
              filteredVideos.map((item, index) => (
                <tr key={index}>
                  <td data-label="Titulli">{item.title}</td>
                  <td data-label="Data e krijimit">{item.createdOn}</td>
                  <td className="actions" data-label="Veprime">
                    <button onClick={() => editVideo(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button onClick={() => deleteVideo(item)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">Nuk u gjetën video!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <button
          className={`pagination-control-btn ${
            currentPage === 1 ? "disabled" : ""
          }`}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        >
          &#8592; Para
        </button>

        <span className="pagination-current-page">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={`pagination-control-btn ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
        >
          Pas &#8594;
        </button>
      </div>
    </div>
  );
};

export default ManageVideo;
